import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input, ViewEncapsulation } from '@angular/core'
import { NgElement, WithProperties } from '@angular/elements'
import { registerCustomElementFactory } from '../../custom-elements/register-custom-element-factory'
import { DecodeHtmlStringPipe } from '../../pipes'

/**
 * @public
 *
 * @deprecated
 */
export type PrintEventButtonElement = NgElement & WithProperties<PrintEventButtonComponent>

/**
 * @public
 *
 * @todo {@link https://jira.gpei.ca/browse/API-4056 API-4056}
 *
 * @deprecated
 *    With the development of the event driven workflow of our
 *    application we may want to reconsider the manner of which
 *    we initiate and action on such small case events
 */
@Component({
  selector: 'gpei-print-event-button',
  templateUrl: './print-event-button.component.html',
  styleUrls: [ './print-event-button.component.sass' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: true,
  imports: [
    CommonModule,
    DecodeHtmlStringPipe
  ]
})
export class PrintEventButtonComponent {

  private _text = 'Print'

  @Input()
  @HostBinding()
  style = ''


  @Input()
  @HostBinding()
  set eventDescription(value: string) {
    if (value.length !== 0) {
      this._text = value
    }
  }

  get text(): string {
    return this._text
  }

  @HostListener('click', ['$event'])
  onPrint() {
    print()
  }
}

/**
 * @public
 *
 * @deprecated
 */
export const registerPrintEventButtonElement = registerCustomElementFactory(PrintEventButtonComponent)
